import { useUserContext } from '@/contexts/UserContext.tsx'
import { acceptInvitation } from '@/repositories/projectRepository.ts'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export const AcceptInvitationPage = () => {
  const { invitationCode } = useParams()
  const navigate = useNavigate()

  const { user } = useUserContext()

  useEffect(() => {
    if (!user) {
      navigate('/login', {
        state: {
          source: 'invites',
          invitationCode,
        },
      })
      return
    }

    if (invitationCode) {
      acceptInvitation(invitationCode).then((project) => {
        navigate('/welcome', {
          replace: true,
          state: {
            project,
          },
        })
      })
    }
  }, [navigate, user, invitationCode])

  return <div />
}
